import React from 'react';
import Header from '../../Layout/Header';
import Footer from '../../Layout/Footer';
import FAQ from './FAQ';
import SeoTagsFooter from './SeoTagsFooter';

function RechargeApi() {
  const rechargeFaqs = [
    {
      question: "What is Mokshiq Recharge API?",
      answer: "Mokshiq Recharge API is a high-speed, multi-operator mobile and DTH recharge API platform powered by automated LAPU routing, high commission rates, and 99.9% success SLA."
    },
    {
      question: "Which operators are supported in Mokshiq Recharge API?",
      answer: "We support all major Indian telecom and DTH operators including Reliance Jio, Bharti Airtel, Vodafone Idea (Vi), BSNL, Tata Play, Dish TV, Sun Direct, Airtel Digital TV, and Videocon D2H."
    },
    {
      question: "What happens if a recharge request fails or times out?",
      answer: "Our intelligent engine automatically attempts instant fallback routing across alternative lapu servers. If still unsuccessful, an immediate automated refund callback is pushed to your endpoint."
    },
    {
      question: "How do I become a White-Label Recharge Distributor?",
      answer: "You can start your own Recharge B2B Portal under your brand name powered by Mokshiq backend infrastructure (Rakle Service Private Limited). Contact sales at sales@mokshiq.in or call +91 7311104571."
    }
  ];

  return (
    <div className="page_wrapper">
      <Header />
      <main className="page_content">
        
        {/* Page Header */}
        <section className="page_header text-center bg-dark section_decoration overflow-hidden py-5" style={{ backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')" }}>
          <div className="container">
            <span className="badge bg-warning text-dark px-3 py-2 text-uppercase mb-3 font-weight-bold" style={{ letterSpacing: '1px' }}>
              <i className="fa-solid fa-bolt me-2"></i>Multi-Operator Recharge API
            </span>
            <h1 className="page_title text-white mb-3 font-weight-bold">Mobile &amp; DTH Recharge Solutions</h1>
            <p className="mx-auto" style={{ maxWidth: '750px', color: '#e2e8f0', fontSize: '1.08rem', lineHeight: '1.6' }}>
              High-speed B2B Mobile &amp; DTH Recharge API Software, Automatic LAPU Switcher, and White-Label Portal Solutions powered by <strong>Rakle Service Private Limited</strong>.
            </p>
            <ul className="breadcrumb_nav unordered_list justify-content-center mt-4">
              <li><a href="/">Home</a></li>
              <li><a href="/services">Services</a></li>
              <li className="active"><a href="#!">Recharge API</a></li>
            </ul>
          </div>
        </section>

        {/* Feature Cards Grid */}
        <section className="recharge_features section_space bg-light">
          <div className="container">
            <div className="heading_block text-center mb-5">
              <h2 className="heading_text text-dark font-weight-bold mb-2">High Commission &amp; Uptime Recharge Platform</h2>
              <p className="heading_description mx-auto mb-0" style={{ color: '#475569', fontSize: '1.05rem', fontWeight: '500', maxWidth: '650px' }}>Designed for Fintech Startups, B2B Portal Owners, Retailers, and Master Distributors.</p>
            </div>

            <div className="row g-4">
              <div className="col-md-6 col-lg-4">
                <div className="card h-100 border p-4 shadow-sm rounded-4 bg-white">
                  <div className="icon_box p-3 bg-primary text-white rounded-circle mb-3 d-inline-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px' }}>
                    <i className="fa-solid fa-mobile-screen-button fa-lg"></i>
                  </div>
                  <h3 className="h5 font-weight-bold text-dark mb-2">Prepaid Mobile Recharge</h3>
                  <p className="small mb-3" style={{ color: '#334155', fontSize: '0.92rem', lineHeight: '1.6' }}>Support for Jio, Airtel, Vi, BSNL prepaid plans, top-ups, data packs, and special tariffs with instant status notifications.</p>
                  <span className="font-weight-bold small" style={{ color: '#16a34a' }}><i className="fa-solid fa-circle-check me-1"></i> Instant 2-Second Processing</span>
                </div>
              </div>

              <div className="col-md-6 col-lg-4">
                <div className="card h-100 border p-4 shadow-sm rounded-4 bg-white">
                  <div className="icon_box p-3 bg-success text-white rounded-circle mb-3 d-inline-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px' }}>
                    <i className="fa-solid fa-tv fa-lg"></i>
                  </div>
                  <h3 className="h5 font-weight-bold text-dark mb-2">DTH &amp; Cable TV Recharge</h3>
                  <p className="small mb-3" style={{ color: '#334155', fontSize: '0.92rem', lineHeight: '1.6' }}>Direct connection with Tata Play, Dish TV, Airtel Digital TV, D2H, and Sun Direct. Real-time customer name &amp; plan lookup API.</p>
                  <span className="font-weight-bold small" style={{ color: '#16a34a' }}><i className="fa-solid fa-circle-check me-1"></i> Customer Info Lookup Included</span>
                </div>
              </div>

              <div className="col-md-6 col-lg-4">
                <div className="card h-100 border p-4 shadow-sm rounded-4 bg-white">
                  <div className="icon_box p-3 bg-warning text-dark rounded-circle mb-3 d-inline-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px' }}>
                    <i className="fa-solid fa-arrows-rotate fa-lg"></i>
                  </div>
                  <h3 className="h5 font-weight-bold text-dark mb-2">Automatic LAPU Switcher</h3>
                  <p className="small mb-3" style={{ color: '#334155', fontSize: '0.92rem', lineHeight: '1.6' }}>Intelligent multi-route lapu fallback mechanism that automatically redirects transactions if a primary operator server is slow.</p>
                  <span className="font-weight-bold small" style={{ color: '#d97706' }}><i className="fa-solid fa-circle-check me-1"></i> 99.9% Transaction Success Rate</span>
                </div>
              </div>

              <div className="col-md-6 col-lg-4">
                <div className="card h-100 border p-4 shadow-sm rounded-4 bg-white">
                  <div className="icon_box p-3 bg-danger text-white rounded-circle mb-3 d-inline-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px' }}>
                    <i className="fa-solid fa-rotate-left fa-lg"></i>
                  </div>
                  <h3 className="h5 font-weight-bold text-dark mb-2">Instant Refund Callback</h3>
                  <p className="small mb-3" style={{ color: '#334155', fontSize: '0.92rem', lineHeight: '1.6' }}>If an operator rejects a transaction, our webhooks automatically reverse the balance to your wallet within milliseconds.</p>
                  <span className="font-weight-bold small" style={{ color: '#dc2626' }}><i className="fa-solid fa-circle-check me-1"></i> Zero Balance Locking</span>
                </div>
              </div>

              <div className="col-md-6 col-lg-4">
                <div className="card h-100 border p-4 shadow-sm rounded-4 bg-white">
                  <div className="icon_box p-3 bg-info text-white rounded-circle mb-3 d-inline-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px' }}>
                    <i className="fa-solid fa-percent fa-lg"></i>
                  </div>
                  <h3 className="h5 font-weight-bold text-dark mb-2">Best Industry Margin &amp; Cashback</h3>
                  <p className="small mb-3" style={{ color: '#334155', fontSize: '0.92rem', lineHeight: '1.6' }}>Earn attractive flat margins and volume-based bonuses across all prepaid telecom and DTH recharge transactions.</p>
                  <span className="font-weight-bold small" style={{ color: '#0284c7' }}><i className="fa-solid fa-circle-check me-1"></i> Highest Margin Structure</span>
                </div>
              </div>

              <div className="col-md-6 col-lg-4">
                <div className="card h-100 border p-4 shadow-sm rounded-4 bg-white">
                  <div className="icon_box p-3 bg-dark text-white rounded-circle mb-3 d-inline-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px' }}>
                    <i className="fa-solid fa-laptop-code fa-lg"></i>
                  </div>
                  <h3 className="h5 font-weight-bold text-dark mb-2">White-Label B2B Portal</h3>
                  <p className="small mb-3" style={{ color: '#334155', fontSize: '0.92rem', lineHeight: '1.6' }}>Launch your own recharge website and android app branded with your company name, logo, domain, and distributor hierarchy.</p>
                  <span className="font-weight-bold small" style={{ color: '#0f172a' }}><i className="fa-solid fa-circle-check me-1"></i> Full Custom Branding</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action Banner (Fixed High-Contrast Dark Mode) */}
        <section className="cta_banner section_space bg-dark text-white py-5">
          <div className="container text-center">
            <h2 className="text-white font-weight-bold mb-3">Ready to Integrate Mokshiq Recharge API?</h2>
            <p className="mb-4 mx-auto" style={{ maxWidth: '650px', fontSize: '1.08rem', color: '#cbd5e1', lineHeight: '1.6' }}>
              Connect with our team to get your API documentation, live API key, and custom margin slab rates today.
            </p>
            <div className="d-flex justify-content-center gap-3 flex-wrap">
              <a href="mailto:sales@mokshiq.in" className="btn btn-warning text-dark font-weight-bold px-4 py-2 rounded-pill shadow">
                <i className="fa-solid fa-envelope me-2"></i>Email Sales (sales@mokshiq.in)
              </a>
              <a href="tel:+917311104571" className="btn btn-outline-light text-white font-weight-bold px-4 py-2 rounded-pill">
                <i className="fa-solid fa-phone me-2"></i>Call +91 7311104571
              </a>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <FAQ 
          faqList={rechargeFaqs} 
          title="Recharge API FAQs" 
          subtitle="Answers to common technical and commercial questions about Mokshiq Recharge solutions." 
        />

      </main>
      <Footer />
      <SeoTagsFooter />
    </div>
  );
}

export default RechargeApi;
